import getProducts from './getProducts'

const productsLib = {
  getProducts
}

export default productsLib
